import React, {ReactNode, useEffect} from 'react';

const LoadingLayout: React.FC<ReactNode> = ({children}) =>{
    useEffect(() => {
    }, [])
    return (
        <div className="bg-gradient w-full vh-100 flex justify-center items-center">
            <div className="main-block xl:rounded-2xl lg:shadow-2xl">
                <div className="h-full w-full flex justify-center items-center bg-blue-500 xl:rounded-2xl lg:shadow-2xl">
                    {children}
                </div>
            </div>
        </div>
    );
};

export default LoadingLayout;
